// config.js
// export const base_url = "http://localhost:4000";
// export const base_url = "http://192.168.1.30:4000"
// export const base_url = "https://api-staging.infinydev.com"

export const base_url = "https://euroapi.europea-dms.com"




export const RECAPTCHA_SITE_KEY = "6LfEdIUtAAAAAEYTvOOP96ce7WJmZszgKcGmCdht"  //production key
// export const RECAPTCHA_SITE_KEY = "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI"   //testing key